import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/auth/use-auth";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_bulk-invoice")({
  component: BulkInvoiceLayout,
});

function BulkInvoiceLayout() {
  const { authUser } = useAuth();

  if (
    authUser?.permissions?.includes("practice_360") ||
    authUser?.permissions?.includes("fulfillment_360")
  ) {
    return <Outlet />;
  }

  return <NotFoundPage />;
}
